import { render, staticRenderFns } from "./website-list.vue?vue&type=template&id=27d2173b"
import script from "./website-list.vue?vue&type=script&lang=js"
export * from "./website-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports